import Fuse from 'fuse.js';

const DEFAULT_FUSE_OPTIONS = {
    threshold: 0.6, // 0.0 = perfect match, 1.0 = match anything
    distance: 100,
    includeScore: true,
    shouldSort: true,
    minMatchCharLength: 1,
    findAllMatches: false,
};

export const createFuzzySearch = (items, keys, options = {}) => {
    const fuseOptions = {
        ...DEFAULT_FUSE_OPTIONS,
        keys,
        ...options
    };

    const fuse = new Fuse(items, fuseOptions);

    return (searchTerm) => {
        if (!searchTerm || !searchTerm.trim()) {
            return items;
        }

        const results = fuse.search(searchTerm.trim());
        return results.map(result => result.item);
    };
};

export const createAssetSearch = (assets) => {
    return createFuzzySearch(assets, [
        'name',
        'title', 
        'category.title',
        'categoryClass.title'
    ], {
        threshold: 0.4, // More strict for asset search
    });
};

export const createPeriodSearch = (periods) => {
    return createFuzzySearch(periods, ['label'], {
        threshold: 0.3, // Very strict for period matching
    });
};

export const createTagSearch = (tags) => {
    return createFuzzySearch(tags, [
        'name',
        'tag',
        'label',
        'id'
    ], {
        threshold: 0.5, // Moderate fuzzy for tags
    });
};

export const createFileSearch = (files) => {
    return createFuzzySearch(files, [
        'displayName',
        'originalName',
        'name'
    ], {
        threshold: 0.4, // Moderate fuzzy for file names
    });
}; 